// src/components/sidebar.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsSuperAdmin(localStorage.getItem('is_super_admin') === 'true');
  }, [location]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <div>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>
      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <h2>Depot Air Cerdas</h2>
        <ul>
          {isSuperAdmin ? (
            <>
              <li><Link to="/admin/register" onClick={handleLinkClick}>Registrasi Admin</Link></li>
              <li><Link to="/admin/tables" onClick={handleLinkClick}>Kelola Data Master</Link></li>
              <li><Link to="/admin/webgis" onClick={handleLinkClick}>WebGIS Depots</Link></li>
              {/* ✅ TAMBAHAN: Link ke halaman Manajemen Akun */}
              <li><Link to="/admin/manage-accounts" onClick={handleLinkClick}>Manajemen Akun</Link></li> {/* Halaman ke-4 */}
              <li><Link to="/admin/smart-weather" onClick={handleLinkClick}>Smart Weather</Link></li>
              <li><Link to="/admin/smart-farming" onClick={handleLinkClick}>Smart Farming</Link></li> {/* ✅ Link baru */}
                  {/* ... tautan admin lainnya */}
              <li><Link to="/admin/gps-tracker" onClick={handleLinkClick}>GPS Tracker</Link></li> {/* ✅ Tambahkan tautan baru */}
         
            </>
          ) : (
            <>
              <li><Link to="/dashboard" onClick={handleLinkClick}>Dashboard</Link></li>
              <li><Link to="/dashboard/pos" onClick={handleLinkClick}>Kasir (POS)</Link></li>
              <li><Link to="/dashboard/pendapatan" onClick={handleLinkClick}>Total Pendapatan</Link></li>
              <li><Link to="/dashboard/trek-motor" onClick={handleLinkClick}>Trek Motor & Lokasi Depot</Link></li>
              <li><Link to="/dashboard/cctv" onClick={handleLinkClick}>CCTV (Under Construction)</Link></li>
              <li><Link to="/dashboard/profile" onClick={handleLinkClick}>Profil</Link></li>
              <li><Link to="/dashboard/pdam-bill" onClick={handleLinkClick}>Perhitungan Tagihan PDAM</Link></li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;